export class TableIconStyle {
  size = 'tb-icon-medium';
  color = '';
  decoration = '';
  decorationColor = '';
  hoverColor = '';

  static normalize(styles: Partial<TableIconStyle>): TableIconStyle {
    const pureStyles = new TableIconStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.hoverColor = styles.hoverColor ?? pureStyles.hoverColor;

    return pureStyles;
  }
}
